import React from 'react';
import { useTheme, withStyles } from '@material-ui/core/styles';
import { Box, CircularProgress, Container, IconButton, Paper, Typography, TableContainer, Table, TableRow, TableCell, TableBody, TableHead, TableFooter, TablePagination, } from '@material-ui/core';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import theme from '../theme';
var TablePreview = function (_a) {
    var loading = _a.loading, data = _a.data, title = _a.title, funMessage = _a.funMessage, child = _a.child, _b = _a.perPage, perPage = _b === void 0 ? 5 : _b;
    var _c = React.useState(0), page = _c[0], setPage = _c[1];
    var _d = React.useState(perPage), rowsPerPage = _d[0], setRowsPerPage = _d[1];
    var emptyRows = rowsPerPage - Math.min(rowsPerPage, ((data === null || data === void 0 ? void 0 : data.length) || 0) - page * rowsPerPage);
    var handleChangePage = function (event, newPage) {
        setPage(newPage);
    };
    var handleChangeRowsPerPage = function (event) {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    if (loading) {
        return (React.createElement(Container, { style: { margin: '20px auto' } },
            "Loading data...",
            React.createElement(CircularProgress, { color: "inherit" })));
    }
    if (!data && !loading && funMessage) {
        return (React.createElement(Container, { style: { margin: '60px 0' } },
            React.createElement(Typography, { variant: "h5", color: "textSecondary" },
                React.createElement(Box, { fontStyle: "oblique", style: { textAlign: 'center' } }, funMessage))));
    }
    if (data && data.length === 0) {
        return (React.createElement(Container, { style: { margin: '60px 0' } },
            React.createElement(Typography, { variant: "h5", color: "textSecondary" },
                React.createElement(Box, { style: { textAlign: 'center' } },
                    "This table is empty",
                    ' ',
                    React.createElement("span", { role: "img", "aria-label": "thinking" }, "\uD83E\uDD14")))));
    }
    if (data) {
        return (React.createElement(Container, { style: { margin: '20px auto' } },
            React.createElement(Container, { style: {
                    padding: 0,
                    display: 'flex',
                    justifyContent: 'space-between',
                } },
                React.createElement("div", { style: { flexGrow: 1 } }, " "),
                React.createElement(Typography, { variant: "h5", color: "textSecondary", style: {
                        textAlign: 'center',
                        flexGrow: 10,
                    } }, title),
                React.createElement("div", { style: { flexGrow: 0 } }, child)),
            React.createElement(Paper, { style: { overflowX: 'auto' } },
                React.createElement(TableContainer, null,
                    React.createElement(Table, { size: "small", "aria-label": "a dense table" },
                        React.createElement(ColoredTableHead, null,
                            React.createElement(TableRow, null, Object.keys(data[0]).map(function (value, i) { return (React.createElement(TableCell, { key: i }, value)); }))),
                        React.createElement(TableBody, null,
                            (rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data).map(function (row, i) { return (React.createElement(TableRow, { key: i }, Object.values(row).map(function (value, j) { return (React.createElement(TableCell, { key: j, style: {
                                    textOverflow: 'ellipsis',
                                    overflowX: 'hidden',
                                    whiteSpace: 'nowrap',
                                } }, "" + value)); }))); }),
                            emptyRows > 0 && (React.createElement(TableRow, { style: { height: 53 * emptyRows } },
                                React.createElement(TableCell, { colSpan: 6 })))),
                        React.createElement(TableFooter, null,
                            React.createElement(TableRow, null,
                                React.createElement(ModifiedTablePagination, { rowsPerPageOptions: [5, 10, 25, { label: 'All', value: -1 }], colSpan: 3, count: data.length, rowsPerPage: rowsPerPage, page: page, SelectProps: {
                                        inputProps: { 'aria-label': 'rows per page' },
                                        native: true,
                                    }, onPageChange: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage, ActionsComponent: TablePaginationActions }))))))));
    }
    return React.createElement(React.Fragment, null);
};
var ColoredTableHead = withStyles({
    root: {
        backgroundColor: theme.palette.mono.light,
        color: theme.palette.text.primary,
        fontWeight: 600,
    },
})(TableHead);
var TablePaginationContainer = withStyles({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
})(Box);
var ModifiedTablePagination = withStyles({
    root: {
        overflow: 'visible',
    },
})(TablePagination);
function TablePaginationActions(props) {
    var theme = useTheme();
    var count = props.count, page = props.page, rowsPerPage = props.rowsPerPage, onPageChange = props.onPageChange;
    var handleFirstPageButtonClick = function (event) {
        onPageChange(event, 0);
    };
    var handleBackButtonClick = function (event) {
        onPageChange(event, page - 1);
    };
    var handleNextButtonClick = function (event) {
        onPageChange(event, page + 1);
    };
    var handleLastPageButtonClick = function (event) {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (React.createElement(TablePaginationContainer, null,
        React.createElement(IconButton, { onClick: handleFirstPageButtonClick, disabled: page === 0, "aria-label": "first page" }, theme.direction === 'rtl' ? React.createElement(LastPageIcon, null) : React.createElement(FirstPageIcon, null)),
        React.createElement(IconButton, { onClick: handleBackButtonClick, disabled: page === 0, "aria-label": "previous page" }, theme.direction === 'rtl' ? React.createElement(KeyboardArrowRight, null) : React.createElement(KeyboardArrowLeft, null)),
        React.createElement(IconButton, { onClick: handleNextButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "next page" }, theme.direction === 'rtl' ? React.createElement(KeyboardArrowLeft, null) : React.createElement(KeyboardArrowRight, null)),
        React.createElement(IconButton, { onClick: handleLastPageButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "last page" }, theme.direction === 'rtl' ? React.createElement(FirstPageIcon, null) : React.createElement(LastPageIcon, null))));
}
export default TablePreview;
